import { render } from "./AuthForgotPage.vue?vue&type=template&id=a95f8c26"
import script from "./AuthForgotPage.vue?vue&type=script&lang=js"
export * from "./AuthForgotPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__